import {
  createFetchActionForNamespace,
  createReducer,
  createFetchReducers,
  createFetchSelectors,
  noDataForAction
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('countries');

export const fetchCountries = createFetchAction({
  name: 'FETCH_COUNTRIES',
  initialAction: noDataForAction,
  stateKey: 'list',
  defaultStateValue: []
});

export const selectCountries = createFetchSelectors(fetchCountries).data;

const fetchReducers = createReducer(
  {},
  {
    ...createFetchReducers(fetchCountries)
  }
);

const reducer = (state = {}, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;
export {default as countriesSaga} from './saga';
